// MemberDashboard.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL;

const MemberDashboard = ({ userData, onLogout }) => {
  const [members, setMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    if (userData && userData.members) {
      setMembers(userData.members);
      if (userData.members.length > 0) {
        setSelectedMember(userData.members[0]);
        fetchTransactions(userData.members[0].Mem_Id);
      }
    }
  }, [userData]);

  const fetchTransactions = async (memberId) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/transactions/member/${memberId}`);

      if (response.data.success) {
        setTransactions(response.data.transactions);
      } else {
        setError('Failed to fetch transactions');
      }
    } catch (err) {
      setError('Error fetching transactions');
      console.error('Fetch transactions error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleMemberSelect = (member) => {
    setSelectedMember(member);
    fetchTransactions(member.Mem_Id);
  };

  const handlePayment = () => {
    if (selectedMember) {
      navigate(`/payment/${selectedMember.Mem_Id}`);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>Member Dashboard</h1>
        <button className="logout-button" onClick={onLogout}>Logout</button>
      </header>

      <div className="dashboard-content">
        <div className="dashboard-sidebar">
          <h3>Your Memberships</h3>
          <ul className="members-list">
            {members.map((member) => (
              <li
                key={member.Mem_Id}
                className={selectedMember?.Mem_Id === member.Mem_Id ? 'active' : ''}
                onClick={() => handleMemberSelect(member)}
              >
                <strong>{member.Mem_Name}</strong>
                <div className="member-details">
                  <span>Company: {member.Company_Name}</span>
                  <span>Scheme ID: {member.Mem_MemberId}</span>

                  <span>Type: {member.Mem_Type}</span>
                  <span>Scheme Type: {member.Mem_FixedOrUnfixed?.toLowerCase() === 'fixed' ? 'Fixed Amount' : 'Unfixed Amount'}</span>


                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="dashboard-main">
          {selectedMember ? (
            <>
              <div className="member-info-card">
                <h3>Selected Member Details</h3>
                <div className="member-info">
                  <p><strong>Company Name:</strong> {selectedMember.Company_Name}</p>
                  <p><strong>Member Name:</strong> {selectedMember.Mem_Name}</p>
                  <p><strong>Member Phone:</strong> {selectedMember.Mem_Phone}</p>
                  <p><strong>Scheme ID:</strong> {selectedMember.Mem_MemberId}</p>
                  <p><strong>Scheme Type:</strong> {selectedMember.Mem_FixedOrUnfixed?.toLowerCase() === 'fixed' ? 'Fixed Amount' : 'Unfixed Amount'}</p>
                  {selectedMember.Mem_FixedOrUnfixed?.toLowerCase() === 'fixed' && (
                    <p><strong>Installment Amount:</strong> ₹{selectedMember.Member_Amount}</p>
                  )}
                  <p><strong>Total Paid Amount:</strong> {selectedMember.Mem_TotalAmountPaid}</p>
                  <p><strong>Total Weight Accumulated:</strong> {selectedMember.Mem_TotalWeight}</p>
                </div>

                <button
                  className="payment-button"
                  onClick={handlePayment}
                >
                  Make Payment
                </button>
              </div>



              <div className="transactions-section">
                <h3>Payment History</h3>
                {loading ? (
                  <p>Loading transactions...</p>
                ) : error ? (
                  <p className="error-message">{error}</p>
                ) : transactions.length === 0 ? (
                  <p>No payment history found</p>
                ) : (
                  <div className="table-container">
                    <table className="transactions-table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Amount</th>
                          <th>Payment ID</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {transactions.map((transaction) => (
                          <tr key={transaction.Transaction_Id}>
                            <td>{formatDate(transaction.Payment_Date)}</td>
                            <td>₹{transaction.Amount}</td>
                            <td>{transaction.Payment_Id}</td>
                            <td>
                              <span className={`status-badge ${transaction.Status}`}>
                                {transaction.Status}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="no-member-selected">
              <p>Please select a membership from the sidebar</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MemberDashboard;